import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate64.scss';

import React from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cnContentBuilderTemplate } from './index';
import { Typography } from '@dataartdev/uikit/Typography';
import { Slider } from '@dataartdev/uikit/Slider';
import { SliderItem } from '@dataartdev/uikit/Slider';
import { AwardCard } from '../../AwardCard/AwardCard';
import { cn } from '@bem-react/classname';
import { IRoot64 } from './models/CTI_64.props';
import { Button } from '@dataartdev/uikit/Button';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';
import { prepareButtonAttrs } from '../../../utils/prepareButtonAttrs';
import { forwardRefWithAs } from '../../../utils/types/PropsWithAsAttributes';

export const ContentBuilderTemplate = forwardRefWithAs<IRoot64>(props => {
  const { type, title, awards, contentId, button } = usePropsHandler(
    cnContentBuilderTemplate(),
    props
  );
  const typeNumber = type.toString();
  const buttonAttr = prepareButtonAttrs(
    button?.link,
    button?.title,
    button?.targetBlank
  );

  const cnAwardsSection = cn('AwardsSection');

  const awardsSlider = {
    watchOverflow: true,
    navigation: true,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      767: {
        spaceBetween: 16,
        slidesPerView: 2.25,
      },
      1200: {
        spaceBetween: 24,
        slidesPerView: 3.25,
      },
      1540: {
        spaceBetween: 24,
        slidesPerView: 4.25,
      },
    },
  };

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <div className={cnAwardsSection()}>
        {title && <Typography.Title size="lg">{title}</Typography.Title>}
        {awards && awards.length > 0 && (
          <Slider {...awardsSlider} className={cnAwardsSection('Slider')}>
            {awards.map(award => {
              return (
                <SliderItem key={award.id}>
                  <AwardCard {...award} />
                </SliderItem>
              );
            })}
          </Slider>
        )}
        {Object.keys(buttonAttr).length > 0 && (
          <div className={cnAwardsSection('Cta')}>
            <Button
              view="primary"
              iconRight={IconArrowRight}
              iconSize="m"
              {...buttonAttr}
            />
          </div>
        )}
      </div>
    </div>
  );
});

export default ContentBuilderTemplate;
